import { useState } from "react";
import {
  RiAddLine,
  RiCalendarLine,
  RiArrowLeftLine,
  RiTimeLine,
  RiCheckLine,
  RiCloseLine,
} from "react-icons/ri";
import { useNavigate } from "react-router-dom";

const RecurringInvoices = () => {
  const navigate = useNavigate();
  const [recurringInvoices, setRecurringInvoices] = useState([
    {
      id: 1,
      customerName: "Tech Solutions Inc.",
      amount: 1499.99,
      frequency: "Monthly",
      nextDate: "2024-03-01",
      status: "Active",
    },
    {
      id: 2,
      customerName: "Design Studio Pro",
      amount: 899.99,
      frequency: "Weekly",
      nextDate: "2024-02-28",
      status: "Paused",
    },
  ]);

  return (
    <div className="max-w-full mx-auto space-y-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <button
            onClick={() => navigate("/billing")}
            className="p-2 hover:bg-gray-100 rounded-lg text-gray-600 transition-colors"
          >
            <RiArrowLeftLine className="w-5 h-5" />
          </button>
          <h1 className="text-3xl font-bold text-gray-900">
            Recurring Invoices
          </h1>
        </div>
        <button className="btn btn-primary flex items-center gap-2">
          <RiAddLine className="w-5 h-5" />
          Create Recurring Invoice
        </button>
      </div>

      <div className="card">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b">
                <th className="text-left py-4 px-4">Customer</th>
                <th className="text-left py-4 px-4">Amount</th>
                <th className="text-left py-4 px-4">Frequency</th>
                <th className="text-left py-4 px-4">Next Invoice</th>
                <th className="text-left py-4 px-4">Status</th>
                <th className="text-right py-4 px-4">Actions</th>
              </tr>
            </thead>
            <tbody>
              {recurringInvoices.map((invoice) => (
                <tr key={invoice.id} className="border-b">
                  <td className="py-4 px-4">{invoice.customerName}</td>
                  <td className="py-4 px-4">${invoice.amount}</td>
                  <td className="py-4 px-4">{invoice.frequency}</td>
                  <td className="py-4 px-4">
                    {new Date(invoice.nextDate).toLocaleDateString()}
                  </td>
                  <td className="py-4 px-4">
                    <span
                      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                        invoice.status === "Active"
                          ? "bg-green-100 text-green-800"
                          : "bg-yellow-100 text-yellow-800"
                      }`}
                    >
                      {invoice.status}
                    </span>
                  </td>
                  <td className="py-4 px-4 text-right">
                    <div className="flex justify-end gap-2">
                      <button className="p-2 hover:bg-gray-100 rounded-lg text-gray-600">
                        <RiTimeLine className="w-5 h-5" />
                      </button>
                      {invoice.status === "Active" ? (
                        <button className="p-2 hover:bg-gray-100 rounded-lg text-red-600">
                          <RiCloseLine className="w-5 h-5" />
                        </button>
                      ) : (
                        <button className="p-2 hover:bg-gray-100 rounded-lg text-green-600">
                          <RiCheckLine className="w-5 h-5" />
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default RecurringInvoices;
